// extracted by mini-css-extract-plugin
export default {"filter-tooltip-icon":"fnpFSplPZige6QlE3w08ug==","filter-tooltip-text":"li2vWpVAe1HkCnZJgp1NWQ=="};